import { render, staticRenderFns } from "./Aging.vue?vue&type=template&id=265772dc&scoped=true"
import script from "./Aging.vue?vue&type=script&lang=js"
export * from "./Aging.vue?vue&type=script&lang=js"
import style0 from "./Aging.vue?vue&type=style&index=0&id=265772dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265772dc",
  null
  
)

export default component.exports